module.exports = __webpack_public_path__ + "img/kyc3-bg.db507b34.png";